var React = require('react');

function AssistappStrokeLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 8a8 8 0 018-8h6.172a1 1 0 01.934 1.358L1.934 35.738A1 1 0 010 35.38V8zm8-6a6 6 0 00-6 6v21.975L12.719 2H8zM32.999.434A1 1 0 0133.823 0H40a8 8 0 018 8v27.24a1 1 0 01-1.933.358L32.89 1.36a1 1 0 01.109-.925zM35.279 2L46 29.857V8a6 6 0 00-6-6h-4.72zM23.663 4.849a1 1 0 01.946.672l8.038 23.224a1 1 0 01-1.123 1.311L16.42 27.332a1 1 0 01-.768-1.31l7.067-20.5a1 1 0 01.944-.673zm.003 4.062l-5.743 16.66 12.275 2.213-6.532-18.873zm-9.84 26.22a1 1 0 011.123-.63l20.068 3.823a1 1 0 01.76.661l2.613 7.693A1 1 0 0137.443 48H10.44a1 1 0 01-.936-1.351l4.322-11.517zm1.576 1.492L11.884 46h24.163l-1.977-5.82-18.668-3.557z"}));
}

AssistappStrokeLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = AssistappStrokeLight;

AssistappStrokeLight.default = AssistappStrokeLight;
